import React from 'react';
import { DownloadSimpleIcon } from '@fronton/icons-react';
import { DownloadCatalogCart, Typography } from 'common/components';
import { strictBreakpoints } from 'common/styles/breakpoints';
import { BATHROOM_CDN_PATH, BATHROOM_ELEMENT_BLOCK } from '../../../../bathroom-constants';
import {
  downloadCatalogBody,
  downloadCatalogImage,
  downloadCatalogImageWrapper,
  downloadCatalogText,
} from './download-catalog-styles';

export const DownloadCatalog = () => (
  <DownloadCatalogCart
    catalogHref='https://storage.yandexcloud.net/lemanapro-ru-landings-docs/bathroom/Catalog-vannye-v2.pdf'
    elementBlock={`${BATHROOM_ELEMENT_BLOCK} / Catalog`}
    elementName='Выберите свой стиль'
    elementText="Скачать каталог ванных комнат"
    linkTitle='Каталог ванных комнат'
  >
    <>
      <div className={downloadCatalogBody}>
        <DownloadSimpleIcon color={'text-minor'} size="l" type="outline" />
        <Typography className={downloadCatalogText} variant="h3">
          Скачать каталог ванных комнат
        </Typography>
      </div>
      <picture className={downloadCatalogImageWrapper}>
        <source
          srcSet={`${BATHROOM_CDN_PATH}/gallery/catalog-icon-ld.png/catalog-icon-ld.png`}
          media={strictBreakpoints['--only-largeDesktop']}
        />
        <source
          srcSet={`${BATHROOM_CDN_PATH}/gallery/catalog-icon-d.png/catalog-icon-d.png`}
          media={strictBreakpoints['--only-desktop']}
        />
        <img
          alt="Изображение каталога"
          className={downloadCatalogImage}
          src={`${BATHROOM_CDN_PATH}/gallery/catalog-icon-m.png/catalog-icon-m.png`}
        />
      </picture>

    </>
  </DownloadCatalogCart>
)
